<template>
  <div class="blog-ara">
    <div class="blog-ara__container">
      <div class="blog__preloader" v-if="loader">
        <div class="blog__preloader-bounce blog__preloader-bounce--one"></div>
        <div class="blog__preloader-bounce blog__preloader-bounce--two"></div>
        <div class="blog__preloader-bounce blog__preloader-bounce--three"></div>
      </div>
      <div class="blog-ara__content--left">
        <div class="blog-tips-andromeda" v-if="(BlogPostfeatured && !loader)">
          <div class="blog-tips-andromeda__container">
            <div class="blog-tips-andromeda__image">
              <div class="blog-tips-andromeda__ribbon" v-for="categoria in BlogPostfeatured.categorias">
                <p class="blog-tips-andromeda__ribbon--text" v-html="categoria.nombre"></p>
              </div>
              <img class="blog-tips-andromeda__img" v-if="BlogPostfeatured.foto"
                :src="BlogPostfeatured.foto.imagen"
                :alt="BlogPostfeatured.nombre"
                :title="BlogPostfeatured.nombre"
                >
              <div class="blog-tips-andromeda__text">
                <p :href="BlogPostfeatured.url" class="blog-tips-andromeda__title" :title="BlogPostfeatured.nombre" v-html="BlogPostfeatured.nombre"></p>
                <div class="blog-tips-andromeda__date">
                  <span class="blog-tips-andromeda__day" v-html="BlogPostfeatured.fecha"></span>
                  <!--
                  <span class="blog-tips-andromeda__month"> Sep </span>
                  <span class="blog-tips-andromeda__year"> 2019 </span>
                  -->
                </div>
                <div class="blog-tips-andromeda__hotel">
                  <span class="blog-tips-andromeda__hotel--name" v-html="BlogPostfeatured.proyecto.nombre"></span>
                </div>
                <a v-if="BlogPostfeatured.total_comentarios"
                  :href="BlogPostfeatured.url"
                  class="blog-tips-andromeda__link--comments">
                  <div class="blog-tips-andromeda__comments">
                    <span class="blog-tips-andromeda__comments--count">{{ BlogPostfeatured.total_comentarios}} </span>
                  </div>
                </a>
                <a class="blog-tips-andromeda__link"
                  :href="BlogPostfeatured.url"
                  :title="initials.vermas">
                  {{ initials.vermas }}
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="blog-latest-posts-antlia" v-if="(BlogPosts.length && !loader)">
          <div class="blog-latest-posts-antlia__container">
            <p class="blog-latest-posts-antlia__title">{{ initials.texttitlepost }}</p>
            <div class="blog-latest-posts-antlia__item" v-for="post in BlogPosts">
              <div class="blog-latest-posts-antlia__image">
                <div class="blog-latest-posts-antlia__ribbon" v-for="categoria in post.categorias">
                  <p class="blog-latest-posts-antlia__ribbon--text" v-html="categoria.nombre"></p>
                </div>
                <img class="blog-latest-posts-antlia__img" v-if="post.foto"
                  :src="post.foto.imagen"
                  :alt="post.nombre"
                  :title="post.nombre"
                  >
                <a v-if="post.total_comentarios"
                  :href="post.url"
                  class="blog-latest-posts-antlia__comments">
                  <span class="blog-latest-posts-antlia__comments--count">{{ post.total_comentarios }}</span>
                </a>
              </div>
              <div class="blog-latest-posts-antlia__text">
                <p :href="post.url" class="blog-latest-posts-antlia__text--title" :title="post.nombre" v-html="post.nombre"></p>
                <div class="blog-latest-posts-antlia__text--date">
                  <span class="blog-latest-posts-antlia__day" v-html="post.fecha"></span>
                  <span class="blog-latest-posts-antlia__hotel" v-html="post.proyecto.nombre"></span>
                  <!---
                  <span class="blog-latest-posts-antlia__month"> Sep </span>
                  <span class="blog-latest-posts-antlia__year"> 2019 </span>
                  -->
                </div>
                <p class="blog-latest-posts-antlia__text--description" v-html="readMore(post.descripcion, 28)"></p>
                <a class="blog-latest-posts-antlia__text--link"
                  :href="post.url"
                  :title="post.nombre">
                  {{initials.vermas}}
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="blog__content" v-else>
          <div class="blog__content-unavailable">{{ initials.txtnodisponible }}</div>
        </div>
      </div>
      <div class="blog-ara__content--right">
        <div class="blog-about-andromeda">
          <div class="blog-about-andromeda__container">
            <p class="blog-about-andromeda__title">{{ initials.pagetitle }}</p>
            <div class="blog-about-andromeda__icon">
            </div>
            <p class="blog-about-andromeda__text"> {{ initials.pagecontent }}
            </p>
          </div>
        </div>
        <div class="blog-social-andromeda">
          <div class="blog-social-andromeda__container">
            <p class="blog-social-andromeda__title" v-if="initials.widgetinstagram">Instagram</p>
            <div class="blog-social-andromeda__instagram" v-if="initials.widgetinstagram">
              <!-- SnapWidget -->
              <iframe class="snapwidget-widget" 
                :src="'https://snapwidget.com/embed/' + initials.widgetinstagram"
                allowtransparency="true"
                frameborder="0"
                scrolling="no"
                style="border:none; overflow:hidden;  width:100%;"></iframe>
            </div>
            <div class="blog-social-andromeda__buttons" v-for="red in social_networks">
              <a :href="red.url" 
                :title="red.tipo_nombre" 
                :class="'blog-social-andromeda__btn blog-social-andromeda__btn--' + red.codigo">
                <!-- Danos un like en--> {{ red.tipo_nombre }}
              </a>
            </div>
          </div>
        </div>
        <div class="blog-offers-andromeda" v-if="banner_offers">
          <div class="blog-offers-andromeda__container">
            <p class="blog-offers-andromeda__title" v-html="banner_offers.titulo"></p>
            <a :href="banner_offers.enlace" 
              class="blog-offers-andromeda__link" 
              :title="banner_offers.titulo">
              <div class="blog-offers-andromeda__image">
                <img class="blog-offers-andromeda__img" 
                    :src="'/'+banner_offers.imagen" 
                    :alt="banner_offers.titulo"
                    :title="banner_offers.titulo">
              </div>
            </a>
          </div>
        </div>
        <div class="blog-category" v-if="Categories.length">
          <div class="blog-category__container">
            <p class="blog-category__title">{{initials.txtcategoria}}</p>
            <categoriaItem
                v-for="item in Categories"
                v-bind:categoria="item"
                v-bind:key="item.id"
                ref="category">
            </categoriaItem>
          </div>
        </div>
        <!--
        {% include "modulos/newsletter/andromeda.html" %}
        -->
      </div>
      <div class="blog-ara__content--bottom">
        <div class="blog-paginator" v-if="pages>1">
          <ul class="blog-paginator__list">
            <li class="blog-paginator__item js-blog-paginator__item-first" v-if="page_obj!==1">
              <a @click="FirstPage" class="blog-paginator__link ">{{initials.txtfirst}}</a>
            </li>

            <li class="blog-paginator__item js-blog-paginator__item-prev" v-if="prev_page">
              <a @click="PreviousPage(page_obj-1)" class="blog-paginator__link ">{{initials.txtprevious}}</a>
            </li>

            <paginatorItem v-for="pag in pages" v-bind:pag="pag" v-bind:key="pag" ref="paginator" ></paginatorItem>

            <li class="blog-paginator__item js-blog-paginator__item-next" v-if="next_page">
              <a @click="NextPage(page_obj+1)" class="blog-paginator__link ">{{initials.txtnext}}</a>
            </li>

            <li class="blog-paginator__item js-blog-paginator__item-last" v-if="pages!==page_obj">
              <a @click="LastPage" class="blog-paginator__link ">{{initials.txtlast}}</a>
            </li>
          </ul>
        </div>
        <div class="blog-category-antlia"
          :is="showCarruselCategories"
          :vermas="initials.vermas"
          :title="initials.texttitlecarrusel"
          :url="initials.categoryurl"></div>
      </div>
    </div>
  </div>
</template>
<script>
    import axios from 'axios';
    import categoriaItem from './categoriaItem.vue'
    import paginatorItem from '../../andromeda/components/paginatorItem.vue'
    import CarruselCategorias from './carruselCategorias.vue'
    import {mapGetters} from 'vuex';
    export default {
          data() {
            return {
                BlogPosts: [],
                BlogPostfeatured: null,
                dateoptions: {year:'numeric', month:'long', day:'numeric' },
                pages:0,
                page_obj:1,
                next_page:null,
                prev_page:null,
                PageFilter:null,
                loader:true,
                Categories:[],
                showCarruselCategories:false,
                social_networks:[],
                banner_offers:null
            }
          },
          components: {
            paginatorItem, categoriaItem, CarruselCategorias
          },
          mounted() {
            var parsedUrl = new URL(window.location.href);
            let url = this.initials.baseurl
            this.getBlog(url)

            this.getCategories(this.initials.categoryurl)
            if (this.initials.socialnetworks) this.social_networks = this.buildJson(this.initials.socialnetworks)
            if (this.initials.imgbanneroffers) this.banner_offers = this.buildJson(this.initials.imgbanneroffers)

            // Montamos componentes auxiliares
            if(this.initials.showcarruselcategorias) this.showCarruselCategories = CarruselCategorias
          },
          methods: {
            getBlog(url){
                var self = this
                this.loader = true
                url = self.constructUrl(url)
                axios.get(url)
                  .then(function (response) {
                    self.BlogPosts = response.data.results
                    self.BlogPostfeatured = self.initials.slugcategoria ? null : self.BlogPosts.shift()
                    self.pages = response.data.paginator
                    self.page_obj = response.data.page_obj
                    if(response.data.next_page){
                        self.next_page = response.data.next_page
                    }else{
                      self.next_page = null
                    }
                    if(response.data.prev_page){
                        self.prev_page = response.data.prev_page
                    }else{
                      self.prev_page = null
                    }
                    self.loader = false
                  })
                  .catch(function (error) {
                    self.BlogPosts = []
                })
            },
            constructUrl(url) {
              let query = url.indexOf('?') > -1 ? '&' : '?'
              if (this.initials.slugcategoria){
                url = `${url}${query}slugcategoria=${this.initials.slugcategoria}`
              } else if (this.initials.filtercode) {
                url = `${url}${query}filter-code=${this.initials.filtercode}`
              }
              return url              
            },
            readMore(string, maxWords){
                var array = string.split(" ");
                var string = array.splice(0, maxWords).join(" ");
                if(array.length > maxWords) {
                    string += "...";
                }
                return string
            },
            buildJson(element) {
              return JSON.parse(element)

            },
            PreviousPage(page){
              var url = this.initials.baseurl+'&page='+ page
              url = this.buildUrl(url)
              this.getBlog(url)
            },
            NextPage(page){
              var url = this.initials.baseurl+'&page='+ page
              url = this.buildUrl(url)
              this.getBlog(url)
            },
            FirstPage(){
              var url = this.initials.baseurl+'&page=1'
              this.getBlog(url)
            },
            LastPage(){
              var url = this.initials.baseurl+'&page='+this.pages
              url = this.buildUrl(url)
              this.getBlog(url)
            },
            buildUrl(url){
              if(this.categoryFilter!= null){
                  url = url+ this.categoryFilter.replace('?', '&')
              }
              if(this.dateFilter != null){
                  url = url + this.dateFilter.replace('?', '&')
              }
              return url
            },
            getCategories(url){
                var self = this
                url = self.constructUrl(url)
                axios.get(url)
                  .then(function (response) {
                    self.Categories = response.data.results
                  })
                  .catch(function (error) {
                    console.log(error);
                })
            }
          },
          watch:{
            categoryFilter: function (val, odlval) {
                var url = this.initials.baseurl+val
                this.getBlog(url)
            },
            PageFilter: function (val, odlval) {
                val = val.replace('?', '&')
                var url = this.initials.baseurl+val
                url = this.buildUrl(url)
                this.getBlog(url)
            }
          },
          computed:{
            ...mapGetters(['initials']),
          }
    }
</script>


// WEBPACK FOOTER //
// src/modules/blog/ara/components/App.vue